import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const clayPlayIdeasAge2: BlogMetaData = {
  title: '2歳の粘土遊びアイデア15選｜3分で準備完了・OK/NG声かけ・つまずきの置き換え（モンテッソーリ流）',
  description:
    '2歳向けの粘土遊びを、今日から再現できるように具体的なアイデア15を厳選。3分準備のコツ、OK/NGの声かけ、よくあるつまずきの置き換え行動、片付けまでをモンテ視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-clay-play-ideas-age-2.webp',
  filePath: buildBlogFilePath('clay-play-ideas-age-2'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
